import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { NextlabMessageHandler } from './nextlab-message-handler'
import { IlsModelService } from '../../services/ils-model.service'
import {
  BaseNextlabMessageHandler,
  BaseNextlabWrapperComponent,
  IlsJsonCreatorService,
  NEXTLAB_ACTOR_PROVIDER,
  ReportService,
} from '@monorepo/angular-common'
import { SendLogActionService } from '../../services/send-log-action.service'
import { CachingStorageService } from '../../services/caching-storage.service'
import {
  Content,
  ImagesService,
  LlmService,
  LogActionService,
  PhaseWithContent,
  ProxyService,
} from '@monorepo/golab-generated'
import { TokenService, UserPlayer } from '@monorepo/auth'
import { NgClass } from '@angular/common'

@Component({
  selector: 'app-nextlab-wrapper',
  templateUrl: './nextlab-wrapper.component.html',
  styleUrls: ['./nextlab-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class NextlabWrapperComponent extends BaseNextlabWrapperComponent {
  private readonly ilsModelService: IlsModelService;
  private readonly storageService = inject(CachingStorageService);
  private readonly logActionService = inject(LogActionService);
  private readonly sendLogActionService = inject(SendLogActionService);
  private readonly proxyService = inject(ProxyService);
  private readonly llmService = inject(LlmService);
  private readonly ilsJsonCreatorService = inject(IlsJsonCreatorService)
  private readonly imagesService = inject(ImagesService);
  private readonly reportService = inject(ReportService);

  constructor() {
    const sanitizer = inject(DomSanitizer);
    const changeDetectorRef = inject(ChangeDetectorRef);
    const ilsModelService = inject(IlsModelService);
    const tokenService = inject(TokenService);
    const actorProvider = inject(NEXTLAB_ACTOR_PROVIDER);

    super(
      sanitizer,
      changeDetectorRef,
      ilsModelService,
      actorProvider,
      (tokenService.getUser() as UserPlayer).nickname,
      true,
    )

    this.ilsModelService = ilsModelService;
  }

  @ViewChild('appIframe') set iframe(iframe: ElementRef<HTMLIFrameElement> | undefined) {
    this.setIframe(iframe)
  }

  @Input() set appContent(content: Content | undefined) {
    this.setAppContent(content)
  }

  protected createNextlabMessageHandler(
    port: MessagePort,
    iframeElement: HTMLIFrameElement,
  ): BaseNextlabMessageHandler {
    return new NextlabMessageHandler(
      port,
      this.storageService,
      this.ilsModelService,
      this.logActionService,
      this.sendLogActionService,
      this.proxyService,
      this.llmService,
      this.ilsJsonCreatorService,
      this.imagesService,
      this.reportService,
      iframeElement,
    )
  }

  protected getCurrentPhase(): PhaseWithContent | undefined {
    const isGlobalContent = this.ilsModelService.globalContentList$.value.some(
      (content) => this._appContent!._id === content._id,
    )
    if (isGlobalContent) {
      return undefined
    }
    return this.ilsModelService.currentPhase
  }
}
